import { t } from '@lingui/macro'

import oak from '../../public/assets/img/oak-square-auth-icon.png'
import google from '../../public/assets/img/oauth-google.svg'
import microsoft from '../../public/assets/img/oauth-microsoft.svg'
import microsoftADFS from '../../public/assets/img/Microsoft_logo.svg'
import windows from '../../public/assets/img/oauth-windows.svg'
import salesforce from '../../public/assets/img/oauth-salesforce.svg'
import okta from '../../public/assets/img/auth-okta.svg'
import centrify from '../../public/assets/img/auth-centrify.png'
import fourth from '../../public/assets/img/auth-fourth.svg'
import jumpCloud from '../../public/assets/img/JumpCloud-logo.svg'
import rockrms from '../../public/assets/img/oauth-rockrms.svg'
import idaptive from '../../public/assets/img/oauth-idaptive-logo.jpg'
import keycloak from '../../public/assets/img/auth-keycloak.png'
import pingidentity from '../../public/assets/img/oauth-pingidentity.svg'
import auth0 from '../../public/assets/img/auth0-icon.svg'

// TODO remove SAML ones-complete SAML oauth config should be in a DB together with image link, color. Image should be stored in our public S3 bucket

// because we need to translate SSO provider name (user can add custom translation)
// SSOProviders should be dynamically generated
export const getSSOProviders = () => ({
  google: {
    name: 'Google',
    title: 'Google',
    description: `For organisations using Google services`,
    icon: google,
    color: '#dd4422'
  },
  googlesaml: {
    name: 'GoogleSAML',
    title: 'Google SAML',
    description: `For organisations using Google accounts configured with SAML`,
    icon: google,
    color: '#dd4422'
  },
  azuresaml: {
    name: 'AzureSAML',
    title: 'Microsoft Azure SAML',
    description: `For organisations using Microsoft Azure Active Directory (AAD) SAML`,
    icon: microsoft,
    color: '#222222'
  },
  adfs: {
    name: 'ADFS',
    title: 'Microsoft ADFS',
    description: `For organisations using Microsoft ADFS`,
    icon: microsoftADFS,
    color: '#347DA2'
  },
  windowslive: {
    name: 'WindowsLive',
    title: 'Windows Live',
    description: `For organisations using Windows Live`,
    icon: windows,
    color: '#2672ec'
  },
  azure: {
    name: 'Azure',
    title: 'Microsoft Azure',
    description: `For organisations using Microsoft Azure Active Directory (AAD)`,
    icon: windows,
    color: '#222222'
  },
  forcedotcom: {
    name: 'Forcedotcom',
    title: 'SalesForce',
    description: `For organisations using SalesForce - Force.com`,
    icon: salesforce,
    color: '#00a1e0'
  },
  okta: {
    name: 'Okta',
    title: 'Okta',
    description: `For organisations using Okta`,
    icon: okta,
    color: '#007dc1'
  },
  centrify: {
    name: 'Centrify',
    title: 'Centrify',
    description: `For organisations using Centrify`,
    icon: centrify,
    color: '#AE0000'
  },
  fourth: {
    name: 'Fourth',
    title: 'Fourth',
    description: `For organisations using Fourth`,
    icon: fourth,
    color: '#2fc9e2',
    domainLock: 'true'
  },
  onelogin: {
    name: 'OneLogin',
    title: 'OneLogin',
    description: `For organisations using OneLogin`,
    icon: fourth,
    color: '#2fc9e2',
    domainLock: 'true'
  },
  jumpcloud: {
    name: 'JumpCloud',
    title: 'JumpCloud',
    description: `For organisations using JumpCloud`,
    icon: jumpCloud,
    color: '#161f32',
    domainLock: 'true'
  },
  rockrms: {
    name: 'RockRMS',
    title: t`Rock RMS`,
    description: `For organisations using Rock RMS`,
    icon: rockrms,
    color: '#EE7725',
    domainLock: 'true'
  },
  idaptive: {
    name: 'Idaptive',
    title: 'Idaptive',
    description: `For organisations using Idaptive`,
    icon: idaptive,
    color: '#3F3962',
    domainLock: 'true'
  },
  oak: {
    name: 'Oak',
    title: t`Oak`,
    description: 'For organisations using Oak',
    icon: oak,
    color: '#0354b2',
    domainLock: 'true'
  },
  keycloakveeam: {
    name: 'keycloakveeam',
    title: 'Keycloak',
    description: 'For organisations using keycloak',
    icon: keycloak,
    color: '#33C6E9',
    domainLock: 'true'
  },
  pingidentity: {
    name: 'pingidentity',
    title: 'PingIdentity',
    description: 'For organisations using PingIdentity',
    icon: pingidentity,
    color: '#BC1F27',
    domainLock: 'true'
  },
  azureb2c: {
    name: 'AzureB2C',
    title: t`Azure B2C`,
    description: `For organisations using Microsoft Azure Active Directory (AAD)`,
    icon: windows,
    color: '#222222'
  },
  auth0: {
    name: 'Auth0',
    title: 'Auth0',
    description: `For organisations using Auth0`,
    icon: auth0,
    color: '#222222'
  }
})
